module.exports = __webpack_public_path__ + "static/media/portraits.da6cc079.png";